import { Component } from 'react';
import classnames from 'classnames';
import classNames from 'classnames/bind';

import styles from './styles.scss';

let cx = classNames.bind(styles);

export default class FormContent extends Component {
  render() {
    var nomargins = this.props.nomargins;
    var nobackground = this.props.nobackground;
    var small = this.props.small;

    let className = cx({
      formContent: true,
      nomargins: nomargins,
      nobackground: nobackground,
      small: small,
    });

    return <div className={classnames(className)}>{this.props.children}</div>;
  }
}
